var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVr = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.714 4H2.033C1.466 4 1 4.466 1 5.033v9.506c0 .567.466 1.032 1.033 1.032h4.464c.557 0 1.043-.354 1.215-.88l1.063-3.18c.395-1.173 2.045-1.173 2.44 0l1.063 3.18c.172.526.668.88 1.225.88h4.464c.567 0 1.033-.465 1.033-1.032V5.286C19 4.577 18.423 4 17.714 4ZM6.477 11.471c-1.782.891-3.553-.87-2.663-2.662.152-.314.405-.567.72-.719 1.781-.89 3.553.87 2.662 2.662a1.643 1.643 0 0 1-.72.72Zm9 0c-1.782.891-3.553-.87-2.663-2.662.152-.314.405-.567.72-.719 1.781-.89 3.553.87 2.662 2.662a1.643 1.643 0 0 1-.72.72Z",
  fill: "currentColor"
})));
export { SvgVr as ReactComponent };